
<template>
    <div class="page">
      <v-container fluid>
        <v-form ref="form">
            <v-row class="d-flex justify-center mt-3">
                <v-col cols="3">
                    <v-text-field
                    label="Setor"
                    v-model="form.filters.nome"
                    outlined
                    dense
                    ></v-text-field>
                </v-col>
                <v-col cols="3">
                    <v-select
                        v-model="form.filters.origem"
                        label="Origem"
                        :items="form.lists.origens"
                        item-text="nome"
                        item-value="id"
                        outlined
                        dense
                    ></v-select>
                </v-col>
                <sigfoco-select-ativo
                    :cols="2"
                    v-model="form.filters.situacao"
                    labelType="Situação"
                ></sigfoco-select-ativo>
              </v-row>
                <v-row class="d-flex justify-center mt-3">
                <sigfoco-date-picker
                :cols="2"
                label="Data Início"
                v-model="form.filters.dataInicio"
                removeIcon
                outlined
                dense
              ></sigfoco-date-picker>
              <sigfoco-date-picker
              :cols="2"
                v-model="form.filters.dataFim"
                label="Data Final"
                removeIcon
                outlined
                dense
              ></sigfoco-date-picker>
            </v-row>
             <div class="text-center">
            <v-col cols="12">
              <sigfoco-tooltip
                text="Buscar"
                icon="mdi-magnify"
                @click="buscarRelatorios"
              ></sigfoco-tooltip>
              <sigfoco-tooltip
                text="Limpar"
                icon="mdi-eraser"
                @click="resetForm"
              ></sigfoco-tooltip>
            </v-col>
          </div>
        </v-form>
        <v-data-table
          class="mt-5 printable"
          :headers="headersAnalitico"
          :items="form.lists.listRelatorios"
          :items-per-page="form.itemsPerPage"
          :footer-props="$footerProps"
          sort-by="dataHoraDaAcao"
          :sort-desc="true"
        >
          <template v-slot:[`item.nome`]="{ item }">
            {{ item.nome }}
          </template>
          <template v-slot:[`item.origem`]="{ item }">
            {{ item.origem }}
          </template>
          <template v-slot:[`item.situacao`]="{ item }">
            <sigfoco-label-ativo-inativo :ativo="item.situacao"></sigfoco-label-ativo-inativo>
          </template>
          <template v-slot:[`item.dataHoraDaAcao`]="{ item }">
            {{ $formatarDataHora(item.dataHoraDaAcao) }}
          </template>
          <template v-slot:[`item.acao`]="{ item }">
            {{ item.acao }}
          </template>
        </v-data-table>
        <sigfoco-buttons
          v-if="form.lists.listRelatorios.length"
          actionText="Baixar PDF"
          cancelText="Baixar CSV"
          @click="baixarRelatorioPdf"
          @cancel="baixarCSVRelatorio"
        ></sigfoco-buttons>
      </v-container>
    </div>
  </template>
  
<script>
    import pageLoadingMixin from "mixins/page-loading.mixin";
    import RelatorioDeLog from "services/relatorios-log/manter-setor-log.service"
    import SetorService from "services/manter-setor.service";
    export default {
        name: "RelatorioLogSetor",
        mixins: [pageLoadingMixin, RelatorioDeLog, SetorService],
    
        data: () => ({
        onReport: false,
        form: {
            filters: {
                nome: null,
                origem: null,
                situacao: null,
                dataInicio: null,
                dataFim: null,
            },
            lists: {
                listRelatorios: [],
                origens: [],
            },
        },
        headersAnalitico: [
            { text: "Setor", align: "center", value: "nome" },
            { text: "Origem", align: "center", value: "origem" },
            { text: "Situação", align: "center", value: "situacao" },
            { text: "Data/Hora da ação", align: "center", value: "dataHoraDaAcao" },
            { text: "Ação", align: "center", value: "acao" },
        ],
        }),
        methods: {
        buscarOrigens() {
            this.$buscarOrigens().then(({ data }) => {
                this.form.lists.origens = data.itens
                .filter(item => item.nome.toLowerCase() !== 'escola')
                .map(item => ({
                    ...item,
                    nome: item.nome.toUpperCase()
                }));
            });
        },
        async buscarRelatorios() {
            const isValid = this.validarDatas();
            if (!isValid) return;
            if (!this.verificarFiltrosPreenchidos()) return;
    
            const preparedRequest = this.prepararRequisicao();
            this.showPageLoading();
            try {
            const { data } = await this.$obterRelatorioLogSetor(this.$montarParamsFilters(preparedRequest));
            this.processarRespostaRelatorio(data);
            } finally {
            this.hidePageLoading();
            }
        },
        validarDatas() {
        const { dataInicio, dataFim } = this.form.filters;
        
        if (dataInicio && dataFim) {
          if (new Date(dataFim) < new Date(dataInicio)) {
            this.$notifyWarning("A Data Final não pode ser anterior à Data Início");
            return false;
          }
          if (new Date(dataInicio) > new Date(dataFim)) {
            this.$notifyWarning("A Data Início não pode ser posterior à Data Final");
            return false;
          }
        }
        return true;
      },
    
        verificarFiltrosPreenchidos() {
          const { nome, situacao, origem, dataInicio, dataFim } = this.form.filters;
          if (!nome && situacao == null && !origem && !dataInicio && !dataFim) {
              this.$notifyWarning("Preencha pelo menos um filtro para retornar informações no relatório.");
              return false;
          }
          
          return true;
        },
    
        async baixarCSVRelatorio() {
            const preparedRequest = this.prepararRequisicao();
            this.showPageLoading();
            try {
            const { data } = await this.$obterRelatorioLogCSVSetor(this.$montarParamsFilters(preparedRequest));
            this.$baixarRelatorioCSV(data, `SIGFOCO.RelatórioDeLogDeSetorCSV`);
            this.$notifySuccess("Operação realizada com sucesso.");
            } finally {
            this.hidePageLoading();
            }
        },
    
        async baixarRelatorioPdf() {
            const preparedRequest = this.prepararRequisicao();
            this.showPageLoading();
            try {
            const { data } = await this.$obterRelatorioLogPDFSetor(this.$montarParamsFilters(preparedRequest));
            const url = URL.createObjectURL(data);
            const link = document.createElement("a");
            link.href = url;
            link.setAttribute("download", "SIGFOCO.RelatórioDeLogDeSetor.pdf");
            document.body.appendChild(link);
            link.click();
            this.$notifySuccess("Operação realizada com sucesso.");
            } finally {
            this.hidePageLoading();
            }
        },
        prepararRequisicao() {
            return {
            nome: this.form.filters.nome,
            origem: this.form.filters.origem,
            dataInicio: this.form.filters.dataInicio,
            dataFim: this.form.filters.dataFim,
            ativo: this.form.filters.situacao,
            };
        },
    
        processarRespostaRelatorio(data) {
          this.form.lists.listRelatorios = data.relatorio?.logsSetor.map(item => ({
              ...item,
              origem: item.origem ? item.origem.toUpperCase() : '',
          }));
        },

        resetForm() {
          this.form.filters.dataInicio = null;
          this.form.filters.dataFim = null;
    
          this.$nextTick(() => {
            this.$set(this.form.filters, 'dataInicio', null);
            this.$set(this.form.filters, 'dataFim', null);
          });
          this.form.filters.nome = null;
          this.form.filters.origem = null;
          this.form.filters.situacao = null;

          this.form.lists.listRelatorios = [];
        }
      },
      mounted() {
          this.buscarOrigens();
      }
    };
</script>